import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  parentBox: {
    backgroundColor: "#FFFFFF",
    margin: "10px 1rem 10px 1rem",
    padding: "10px",
    borderRadius: "8px",
    height: "auto",
    boxShadow:"rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;"
  },
  childBox: {
    backgroundColor: "#000000",
    color: "#ffffff",
    height: "auto",
    borderRadius: "7px",
    padding: "15px",
  },
  grandChild: {
    width: "100%",
    height: "auto",
  },
  gridStyling: {
    margin: 0,
    "@media (max-width:768px)": {
      textAlign: "center",
    },
  },
  numbersStyling: {
    color: "#FFAF4A",
    fontSize: "25px",
    fontWeight: "bold",
  },
  gridBorder: {
    borderRight: "1px solid #ffffff",
    "@media (max-width:768px)": {
      borderRight: "none",
      borderBottom: "1px solid #ffffff",
    },
  },
  specialGridBorder: {
    borderRight: "1px solid #ffffff",
    "@media (max-width:768px)": {
      borderBottom: "1px solid #ffffff",
    },
    "@media (max-width:1199px)": {
      borderRight: "none",
    },
  },
  gridPaddingLeft: {
    paddingLeft: "40px",
    "@media (max-width:1199px)": {
      paddingLeft: "16px",
    },
  },
}));

export default useStyles;
